import { AUTH_HEADERS } from '@libs/core';
import type { PointsModel } from '@libs/common-types';
import { client } from '../../client';
import { getAccessToken } from '../../utils';
import { CWEA_ENDPOINTS } from '../../constants';

export async function getPointsHistory() {
    const token = getAccessToken();

    if (!token) {
        return null;
    }

    const url = CWEA_ENDPOINTS.loyalty.getPointsHistory;
    return await client.cwea<PointsModel[]>(url, {
        headers: {
            [AUTH_HEADERS.AUTHORIZATION]: `Bearer ${token}`,
        },
    });
}
